import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import SideMenu from "../SideMenu/SideMenu";
import BottomNav from "../BottomNavigation/BottomNavigation";
import { useStyles } from "./styles";

const AppLayout = ({ children, title }) => {
  const classes = useStyles();
  const [isDesktop, setIsDesktop] = useState(false);
  const [sideMenuVisible, setSideMenuVisible] = useState(false);
  const [activeTab, setActiveTab] = useState(() => parseInt(localStorage.getItem("activeTab"), 10) || 0);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
  };


  return (
    <div className={classes.pageWrapper}>
      {/* Conditionally render SideMenu based on screen size */}
      {isDesktop && (
        <SideMenu
          visible={sideMenuVisible}
          onClose={() => setSideMenuVisible(false)}
          activeTab={activeTab}
        />
      )}

      {/* Main content area */}
      <div
        className={`${classes.contentWrapper} ${
          isDesktop && sideMenuVisible ? classes.contentWithSideMenu : ""
        }`}
      >
        <Navbar
          title={title}
          sideMenuVisible={isDesktop && sideMenuVisible}
          toggleSideMenu={() => setSideMenuVisible(!sideMenuVisible)}
        />
        
        {/* Render children or pass tab change handler */}
        {typeof children === 'function' ? children(handleTabChange, activeTab) : children}
      </div>

      {/* BottomNav for mobile view */}
      {!isDesktop && <BottomNav />}
    </div>
  );
};

export default AppLayout;
